<template>
  <el-dialog
      v-if="dialogVisible"
      v-el-drag-dialog
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      title="附件信息"
      width="1000px">
    <vm-table
        ref="vmTable"
        :filter.sync="filter"
        module="basic"
        url="sAPPurchaseOrders/attachment">
      <template slot="adSearch">
        <vm-search label="销售订单号">
          <el-input v-model.trim="filter.salesOrderNo" clearable/>
        </vm-search>
        <vm-search label="附件名称">
          <el-input v-model.trim="filter.fileName" clearable/>
        </vm-search>
      </template>
      <el-table-column prop="salesOrderNo" align="center" label="销售订单号" width="150px"/>
      <el-table-column prop="fileName" label="附件名称"/>
      <el-table-column
          fixed="right"
          align="center"
          width="100px"
          label="操作">
        <template v-slot="scope">
          <el-button type="primary" @click="handleDownload(scope)">下载</el-button>
        </template>
      </el-table-column>
    </vm-table>
  </el-dialog>
</template>

<script>
  import VmTable from "@/components/VmTable";
  import VmSearch from "@/components/VmSearch";

  export default {
    name: "PurchaseOrderAttachment",
    components: {VmTable, VmSearch},
    data() {
      return {
        dialogVisible: false,
        filter: {},
      };
    },
    methods: {
      open(salesOrderNos) {
        this.dialogVisible = true;
        this.filter.salesOrderNos = salesOrderNos;
        this.$nextTick(() => {
          this.$refs.vmTable.getList(1);
        });
      },
      handleDownload(scope) {
        window.open(window.config.fileServerUrl + scope.row.filePath);
      },
    },
  };
</script>

<style scoped>

</style>